module.exports = __webpack_public_path__ + "img/8-PHM.a3a40a8.jpg";